"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Float extends _react.default.Component {
  render() {
    const {
      schema,
      value,
      name,
      onChange,
      readOnly,
      ...rest
    } = this.props; /* 
                    parseDecimal = value => {
                    return !parseFloat(value) || !Number(value) || value.endsWith('.') ? value : parseFloat(value);
                    }; */

    return /*#__PURE__*/_react.default.createElement("input", {
      type: 'number',
      className: 'form-control',
      step: "0.01",
      value: value,
      onChange: event => onChange(event.target.value)
    });
  }
}
var _default = exports.default = Float;
module.exports = exports.default;